import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBrackets1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H8V5H5V19H8V21H3V3ZM16 3H21V21H16V19H19V5H16V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBrackets1;
